// extracted by mini-css-extract-plugin
module.exports = {"container":"privacytext-module--container--131BB","head":"privacytext-module--head--3Ts51"};